



































































import { Component, Prop, Watch } from 'vue-property-decorator';
import MixinDialog from '@/plugins/podolib/services/helper/mixins/dialog';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';
import { Severity } from '@sentry/types';

type TFields = {
  _id: {
    value: string;
  };
};

@Component
export default class PatientAcquisitionDelete extends MixinDialog {
  @Prop({ required: true }) private patient!: TEntity<TPatient>;
  @Prop({ default: null }) private acquisitionId?: TEntity<TAcquisition>['_id'];

  dialog = false;
  status: any = {
    success: false,
    loading: false,
    error: null,
  };
  internalPatient: TEntity<TPatient> | null | undefined = null;
  internalAcquisitionId: TEntity<TAcquisition>['_id'] | null | undefined = null;

  get _patientId() {
    return this.internalPatient!._id || this._patient!._id;
  }
  get _acquisitionId() {
    return this.internalAcquisitionId || this.acquisitionId;
  }
  get _patient(): TEntity<TPatient> | null {
    if (this.patient) return this.patient;
    if (!this._patientId) return null;
    return this.$pdc.entities!.patients.getStoredEntityById(this._patientId);
  }
  get acquisition(): TEntity<TAcquisition> | null {
    if (!this._acquisitionId || !this._patient) return null;
    return this._patient.acquisitions.find((x) => x._id === this._acquisitionId) || null;
  }

  @Watch('dialog')
  onDialogChanged(state: boolean) {
    if (state) {
      // Reset flags
      this.status.success = false;
      this.status.error = null;
    }
  }

  async remove() {
    if (!this._patientId || !this.acquisition) {
      this.status.error = new Error('Missing data') as any;
      this.$sentry.captureException(this.status.error);
      return;
    }

    const analyticsPayload = {
      analysisId: this.acquisition!._id,
    };

    try {
      this.status.pending = true;
      await this.$pdc.entities!.acquisitions.remove(this.acquisition!._id);

      // Analytics
      this.$pdc.analytics?.actions.trackSuccess('Analysis Deleted', analyticsPayload);

      let patient = this._patient;
      patient!.acquisitions = this._patient!.acquisitions.filter((x: any) => x._id !== this._acquisitionId);
      // this.$store.commit('pdc/entities/patients/PATCH_ONE', patient);
      this.status.success = true;
      if (this.allowRedirect && this.$route.path !== `/patient/${this._patientId}`) {
        await this.$router.push({
          path: `/patient/${this._patientId}`,
        });
      }
    } catch (e) {
      // Analytics
      this.$pdc.analytics?.actions.trackFailure('Analysis Deleted', e, analyticsPayload);
      // Set 'error' flag
      this.status.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    } finally {
      // Reset 'pending' flag
      this.status.pending = false;
    }
  }

  open(patient: TEntity<TPatient>, acquisitionId: TEntity<TAcquisition>['_id']) {
    this.internalPatient = patient;
    this.internalAcquisitionId = acquisitionId;
    this.dialog = true;
  }
}
